import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { RadiationMachineFormComponent } from './radiation-machine-form.component';
const ɵ0 = (createTranslateLoader);
export class RadiationMachineFormModule {
}
RadiationMachineFormModule.rootComponent = RadiationMachineFormComponent;
export function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export { ɵ0 };
